import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Box } from 'foundations-components/transitional/components/Box';
import { Link } from 'foundations-components/transitional/components/Link';
import { View } from 'foundations-components/components/View';
import LearnMoreModal from '../base/LearnMoreModal';
import { useModalTracker } from '../../../hooks/tracking';
import { ACADEMY_LESSON_CONNECT_DOMAIN_URL, ACADEMY_LESSON_CONNECT_EMAIL_DOMAIN_URL, KNOWLEDGE_BASE_CONNECT_DOMAIN_URL, KNOWLEDGE_BASE_CONNECT_EMAIL_DOMAIN_URL } from '../../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ConnectDomainModal = ({
  onClose
}) => {
  const {
    trackLink
  } = useModalTracker('ConnectDomainModal');
  return /*#__PURE__*/_jsxs(LearnMoreModal, {
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.modal.connectDomain.heading"
    }),
    illustrationName: "primary-hosting",
    onClose: onClose,
    children: [/*#__PURE__*/_jsx(Box, {
      marginBlockEnd: "500",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.connectDomain.description"
      })
    }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "setup-guide-components.modal.connectDomain.p1"
    }), /*#__PURE__*/_jsx(Link, {
      external: true,
      href: KNOWLEDGE_BASE_CONNECT_DOMAIN_URL,
      onClick: () => trackLink('connect domain article'),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.readInstructions"
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "600",
      children: /*#__PURE__*/_jsx(Link, {
        external: true,
        href: ACADEMY_LESSON_CONNECT_DOMAIN_URL,
        onClick: () => trackLink('connect domain lesson'),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "setup-guide-components.modal.watchVideo"
        })
      })
    }), /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "setup-guide-components.modal.connectDomain.p2"
    }), /*#__PURE__*/_jsx(Link, {
      external: true,
      href: KNOWLEDGE_BASE_CONNECT_EMAIL_DOMAIN_URL,
      onClick: () => trackLink('connect email domain article'),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.readInstructions"
      })
    }), /*#__PURE__*/_jsx(Link, {
      external: true,
      href: ACADEMY_LESSON_CONNECT_EMAIL_DOMAIN_URL,
      onClick: () => trackLink('connect email domain lesson'),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.watchVideo"
      })
    })]
  });
};
ConnectDomainModal.propTypes = {
  onClose: PropTypes.func
};
export default ConnectDomainModal;